import { HealthStatus } from './health-status.enum';

export interface HealthCheckResponseItem {
  status: HealthStatus;
  description: string | null;
  data: Record<string, unknown>;
}

/**
 * `results` is keyed by the health-check names registered in the API's `AddHealthChecks()` call
 * (currently `OrderFlowDbContext`, `redis`, `fasApi`, `restrictedSecurities`). Typed as a record
 * rather than named properties so adding a check on the backend doesn't silently resolve to
 * `undefined` here — consumers should iterate or look up defensively.
 */
export interface HealthCheckResponse {
  results: Record<string, HealthCheckResponseItem>;
  status: HealthStatus;
}

export const HEALTH_CHECK_FAS_API = 'fasApi';

/** Display names for the known check keys; unknown keys fall back to the raw key. */
export const HEALTH_CHECK_LABELS: Record<string, string> = {
  OrderFlowDbContext: 'Database',
  redis: 'Cache',
  fasApi: 'FA API',
  restrictedSecurities: 'Restricted securities'
};
